import {Sprite, Text} from 'pixi.js';
import {CoreDI, CurrencyFormatter, DeviceType, inject, LanguageService} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {IKeypadInfoView} from '@gongxigames/framework/slot/modules/keypadInfo/IKeypadInfoView';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad';
import {View} from '@gongxigames/framework/slot/fragments/module/view';

export class KeypadInfoElementsView extends View implements IKeypadInfoView {
    public static readonly NAME: symbol = Symbol('KeypadInfoElementsView');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.DESKTOP;

    @inject(CoreDI.CurrencyFormatter)
    protected _currencyFormatter!: CurrencyFormatter;

    @inject(CoreDI.LanguageService)
    protected _languageService!: LanguageService;

    protected _leftTicker!: Text;
    protected _rightTicker!: Text;
    protected _pointsBalance!: Text;
    protected _balancePanel!: Sprite;
    protected _freeSpinsInfoPanel!: Sprite;

    public init(): void {
        super.init();

        this.initGraphicElements();
    }

    protected initGraphicElements(): void {
        const freeSpinsOfLabel = (this.mainSprite.getChildByName<Sprite>('fgPanel')).getChildByName<Text>('ofLabel');
        const freeSpinsLabel = (this.mainSprite.getChildByName<Sprite>('fgPanel')).getChildByName<Text>('freeGamesLabel');

        freeSpinsOfLabel.text = this._languageService.get('ofLabel');
        freeSpinsLabel.text = this._languageService.get('freeGamesLabel');
        this._balancePanel = this.mainSprite.getChildByName<Sprite>('balancePanel');
        this._freeSpinsInfoPanel = this.mainSprite.getChildByName<Sprite>('fgPanel');
        this._leftTicker = this.mainSprite.getChildByName<Text>('tickerLeft');
        this._rightTicker = this.mainSprite.getChildByName<Text>('tickerRight');
        this._pointsBalance = this.mainSprite.getChildByName<Text>('pointsBalance');
    }

    public initializeMainGameLayout(): void {
        this._freeSpinsInfoPanel.visible = false;
    }

    public initializeFreeSpinsLayout(): void {
        this._freeSpinsInfoPanel.visible = true;
    }

    public refreshBalance(balance: number): void {
    }

    public refreshFreeSpinsInfo(freeSpinsLeft: number, freeSpinsTotal: number): void {
        (this._freeSpinsInfoPanel.getChildByName<Text>('currentText')).text = '' + freeSpinsLeft;
        (this._freeSpinsInfoPanel.getChildByName<Text>('terminalText')).text = '' + freeSpinsTotal;

        this.refreshAlignForFSText();
    }

    protected refreshAlignForFSText(): void {
        const currentText: Text = (this._freeSpinsInfoPanel.getChildByName<Text>('currentText'));

        currentText.x = 213 - currentText.width;
    }

    public refreshTotalBetInfo(totalBetValue: string): void {
        // functionality does not exist for desktop
    }

    public refreshLeftTicker(text: string): void {
        this._leftTicker.text = text;
    }

    public refreshRightTicker(text: string): void {
        this._rightTicker.text = text;
    }

    public refreshPointsBalance(points: number): void {}

    public set balanceLabel(value: Text) {
        value.text = this._languageService.get('cashLabel');
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadView.NAME).mainSprite;
    }
}
